export const NAME = 'netlify-cms-widget-inline-select';
